const thumbStrip = {

	elements: {},

	totalSlides: 0,

	currentSlide: 0,

	slideshowInstance: null,

    activeSlideClass: 'slideshow__dot--active',
    
    resizeSlideshow() {
        const firstImage = this.elements.slideshow.find('.thumb-strip__image').first();
        const height = firstImage.height();

        if( height )
        {
            this.elements.slideshow.get(0).style.setProperty('--js-image-height', (height/2) + "px");
        }
    },

	bind()
	{
        this.elements.slideshow.on('init', (event, slick) => {
            
            this.elements.slideshow.find('img').on('load', e => {
                this.resizeSlideshow();
            });
            
            this.elements.slideshow.addClass('thumb-strip--ready');

            this.resizeSlideshow();
        });

        this.elements.slideshow.on('breakpoint', (event, slick, breakpoint) => {
            this.resizeSlideshow();
        });

        const responsiveSettings = [{
            breakpoint: 960,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4
            }
        }, {
            breakpoint: 700,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3
            }
        }, {
            breakpoint: 530,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }];

        this.elements.slideshow.slick({
            'slide': '.js-slide',
            'infinite': true,
            
            'arrows': true,
            'prevArrow': $('.js-ts-prev'),
            'nextArrow': $('.js-ts-next'),

            'dots': false,
            'slidesToShow': 6,
            'slidesToScroll': 6,
            'responsive': responsiveSettings,

            customPaging : function(slider, i) {
                return '<div class="slideshow__dot"></div>';
            }
        });

        window.addEventListener('resize', e => {
            this.resizeSlideshow();
        })
	},

	cacheDom()
	{
		const slideshow = $('.js-related-experts');
		this.elements.slideshow = slideshow;
    },

	init()
	{
		this.cacheDom();
		this.bind();
	}

};

export default thumbStrip;